import { templateMap } from '@/api';
import { get } from '@/common/request';

/**
 * 类目模板列表
 * https://yapi.lanhanba.com/mock/289/api/categoryTemplate/page
 */

class TemplateStore {
  resTemplateList(params: any) {
    return get(templateMap.get('list'), { ...params }, { isMock: false, needHint: true, proxyApi: '/resserv' });
  }

  /**
   * 类目模板详情
   * https://yapi.lanhanba.com/mock/289/api/categoryTemplate/detail
   */

  resTemplateDetail(categoryId, categoryTemplateId) {
    return get(templateMap.get('detail'), { categoryId, categoryTemplateId }, { needCancel: false, needHint: true, proxyApi: '/resserv' });
  }
}

export default new TemplateStore();
